import { Injectable, Inject, Renderer2, RendererFactory2, PLATFORM_ID } from '@angular/core';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EnvService } from './env.service';
import { isPlatformBrowser } from '@angular/common';
declare var gapi: any;
declare var google: any;
@Injectable({
    providedIn: 'root'
})
export class GoogleAnalyticsService {
    private gtmId = 'G-D7CD87HNWT';
    private renderer: Renderer2;
    private gapiPromise: Promise<void>;
    isPlatformBrowser: boolean;
    @Inject(PLATFORM_ID) private platformId: any

    // private clientId = '1014438195138-199891earggs30teujpbm1dpva940g6b.apps.googleusercontent.com';
    // private apiKey = 'AIzaSyByOKTQNo8JtrA7wzx_T3JjwoA-T09K9lM';
    // private discoveryDocs = ['https://analyticsdata.googleapis.com/$discovery/rest?version=v1beta'];
    // private scopes = 'https://www.googleapis.com/auth/analytics https://www.googleapis.com/auth/analytics.readonly';
    // private propertyId = 449080752;
    constructor(private ccService: NgcCookieConsentService,
        rendererFactory: RendererFactory2,
        private http: HttpClient, private EnvService: EnvService
    ) {
        // this.loadGoogleApi()
        if (isPlatformBrowser(this.platformId)) {
            this.gapiPromise = new Promise<void>((resolve) => {
                const script = document.createElement('script');
                script.src = 'https://apis.google.com/js/api.js';
                script.onload = () => {
                    gapi.load('client:auth2', resolve);
                };
                document.body.appendChild(script);
            });
        }
        this.renderer = rendererFactory.createRenderer(null, null);
        this.isPlatformBrowser = isPlatformBrowser(this.platformId);
    }

    loadGTM() {
        if (isPlatformBrowser(this.platformId)) {
            const script = document.getElementById('gtm-script');
            const script2 = document.getElementById('gtm-script2');
            if (!(script && script2)) {
                let gaScript = document.createElement('script');
                gaScript.setAttribute('async', 'true');
                gaScript.setAttribute('id', 'gtm-script');
                gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${this.gtmId}`);
                let gaScript2 = document.createElement('script');
                gaScript2.setAttribute('id', 'gtm-datalayer');
                gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${this.gtmId}\');`;
                document.head.appendChild(gaScript);
                document.head.appendChild(gaScript2);
                this.addNoScriptElement();
                this.loadDataLayer();
            }
        }
    }
    loadDataLayer() {
        if (isPlatformBrowser(this.platformId)) {
            window.dataLayer = window.dataLayer || [];
            // Define gtag function if not already defined
            this.updateConsentAdStorage('granted');
        }
    }
    updateConsentAdStorage(consentStatus: 'granted' | 'denied') {
        if (isPlatformBrowser(this.platformId)) {
            if (typeof window.gtag === 'undefined') {
                window.gtag = function () {
                    window.dataLayer.push(arguments);
                };
            }
            window.gtag('consent', 'update', {
                'ad_storage': consentStatus,
                'ad_user_data': consentStatus,
                'ad_personalization': consentStatus,
                'analytics_storage': consentStatus,
            });
        }
    }
    removeGTM() {
        if (isPlatformBrowser(this.platformId)) {
            this.removeNoScriptElement();
            this.clearAllCookies();
            const gtmScript = document.getElementById('gtm-script');
            const gtmScript2 = document.getElementById('gtm-datalayer');
            if (gtmScript)
                gtmScript.remove();
            if (gtmScript2)
                gtmScript2.remove();
            const defaultConsent = {
                'ad_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied',
                'analytics_storage': 'denied'
            };
            // Ensure dataLayer is initialized
            window.dataLayer = window.dataLayer || [];
            // update default consent 
            window?.gtag('consent', 'update', defaultConsent);
            let data: any = window;
            if (data.dataLayer) {
                data.dataLayer.length = 0;
            }
        }
    }
    addNoScriptElement() {
        if (isPlatformBrowser(this.platformId)) {
            const noScript = document.getElementById('gtm-noscript');
            if (!noScript) {
                const noScript = this.renderer.createElement('noscript');
                noScript.id = 'gtm-noscript';
                const iframe = this.renderer.createElement('iframe');
                this.renderer.setAttribute(iframe, 'src', `https://www.googletagmanager.com/ns.html?id=${this.gtmId}`);
                this.renderer.setAttribute(iframe, 'height', '0');
                this.renderer.setAttribute(iframe, 'width', '0');
                this.renderer.setStyle(iframe, 'display', 'none');
                this.renderer.setStyle(iframe, 'visibility', 'hidden');
                this.renderer.appendChild(noScript, iframe);
                const body = document.body;
                body.insertBefore(noScript, body.firstChild);
            }
        }
    }
    removeNoScriptElement() {
        if (isPlatformBrowser(this.platformId)) {
            const noScript = document.getElementById('gtm-noscript');
            if (noScript) {
                noScript.remove();
            }
        }
    }
    clearAllCookies() {
        if (isPlatformBrowser(this.platformId)) {
            const cookies = document.cookie.split(";");
            for (let cookie of cookies) {
                const eqPos = cookie.indexOf("=");
                const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
            }
        }
    }

    checkConsentAndLoadGTM(): void {
        if (this.ccService && this.ccService.hasConsented()) {
            this.loadGTM();
        }
    }

    // private loadGoogleApi() {
    //     const script = document.createElement('script');
    //     script.src = 'https://accounts.google.com/gsi/client';
    //     script.onload = () => this.initializeClient();
    //     document.body.appendChild(script);
    // }
    // private initializeClient() {
    //     // await new Promise(resolve => gapi.load('client:auth2', resolve));

    //     // await gapi.auth2.init({
    //     //   client_id: this.clientId
    //     // });
    //     google.accounts.id.initialize({
    //         client_id: this.clientId,
    //         callback: (response: any) => this.handleCredentialResponse(response)
    //     });
    //     google.accounts.id.prompt(); // display the One Tap prompt
    //     console.error();
    // }
    // private handleCredentialResponse(response: any) {
    //     const { credential } = response;
    //     console.log('Credential Response', response);
    //     this.exchangeToken(credential);
    // }
    // private exchangeToken(credential: string) {
    //     fetch('https://oauth2.googleapis.com/token', {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/x-www-form-urlencoded'
    //         },
    //         body: `code=${credential}&client_id=${this.clientId}&client_secret=YOUR_CLIENT_SECRET&redirect_uri=YOUR_REDIRECT_URI&grant_type=authorization_code`
    //     })
    //         .then(response => response.json())
    //         .then((data: any) => {
    //             console.log('Token Exchange Response', data);
    //             this.runReport(data.access_token);
    //         })
    //         .catch(error => {
    //             console.error('Error exchanging token', error);
    //         });
    // }
    // public signIn() {
    //     google.accounts.oauth2.initTokenClient({
    //         client_id: this.clientId,
    //         scope: this.scopes,
    //         callback: (response: any) => {
    //             console.log('Token Client Response', response);
    //             this.runReport(response.access_token);
    //         }
    //     }).requestAccessToken();
    // }
    // public signOut() {
    //     return gapi.auth2.getAuthInstance().signOut()
    //         .then(() => {
    //             console.log('Sign-out successful');
    //         }, (error: any) => {
    //             console.error('Error signing out', error);
    //         });
    // }

    // public async runReport(accessToken: string) {
    //     try {
    //         const response = await fetch(`https://analyticsdata.googleapis.com/v1beta/properties/${this.propertyId}:runReport`, {
    //             method: 'POST',
    //             headers: {
    //                 'Authorization': `Bearer ${accessToken}`,
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({
    //                 dateRanges: [
    //                     {
    //                         startDate: '28daysAgo',
    //                         endDate: 'yesterday'
    //                     }
    //                 ],
    //                 dimensions: [
    //                     {
    //                         name: 'pagePath'  // For web pages
    //                     },
    //                     {
    //                         name: 'eventName'  // To distinguish between event types
    //                     }
    //                 ],
    //                 metrics: [
    //                     {
    //                         name: 'eventCount', // Total page and screen views
    //                     }
    //                 ],
    //                 dimensionFilter: {
    //                     filter: {
    //                         fieldName: 'eventName',
    //                         inListFilter: {
    //                             values: ['download', 'page_view']  // Adjust to your event names
    //                         }
    //                     }
    //                 }
    //             })
    //         });
    //         const data = await response.json();
    //         console.log('Report Data:', data);
    //     } catch (error) {
    //         console.error('Error running report', error);
    //     }
    // }
    getAnalytics(): Observable<any> {
        return this.http.get<any>(this.EnvService.siteApiUrl + "web/google-analytics");
    }

}
